import { useState } from 'react';
import { X, Sparkles, Trash2 } from 'lucide-react';
import { useOrg } from '../context/OrgContext';
import { useDeals } from '../context/DealsContext';
import { WorkfrontAiChat, clearWorkfrontChatHistory } from './WorkfrontAiChat';
import { NlqChatPanel } from '../nlq/components/NlqChatPanel';
type AiMode = 'workfront' | 'nlq';
interface Props {
  onClose: () => void;
}
const WORKFRONT_ORG_NAME = 'Workfront AdobeRM';
export function AiChatSidebar({
  onClose
}: Props) {
  const [mode, setMode] = useState<AiMode>('nlq');
  const {
    selectedOrg
  } = useOrg();
  const {
    deals,
    touchpoints
  } = useDeals();
  const isWorkfrontOrg = selectedOrg?.orgName === WORKFRONT_ORG_NAME || selectedOrg?.imsOrgId?.includes('workfront');
  const handleClearChat = () => {
    if (mode === 'workfront') {
      clearWorkfrontChatHistory();
    } else {
      localStorage.removeItem('ai-chat-nlq');
    }
    window.location.reload();
  };
  return <div className="ai-sidebar ai-sidebar-enter" onClick={e => e.stopPropagation()} data-id="element-61" data-mp="hn2e4v2sbmhe">
      {/* Header */}
      <div className="ai-sidebar-header" data-id="element-62" data-mp="142n3xuknumuh">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }} data-id="element-63" data-mp="1824akrbtpq18">
          <Sparkles size={16} style={{
          color: '#7c3aed'
        }} data-id="element-64" data-mp="uapqeh66jisl" />
          <span style={{
          fontWeight: 700,
          fontSize: 14,
          color: '#1a1a2e'
        }} data-id="element-65" data-mp="ua7lyx9d5y9l">
            {mode === 'workfront' ? 'Workfront AI' : 'OnDemand AI'}
          </span>
        </div>
        <div style={{
        display: 'flex',
        gap: 4
      }} data-id="element-66" data-mp="kb8ped1vht2y">
          <button onClick={handleClearChat} title="New conversation" className="ai-icon-btn" data-id="element-67" data-mp="pbd4pzr1ohrl">
            <Trash2 size={14} data-id="element-68" data-mp="p90fd1iyj54i" />
          </button>
          <button onClick={onClose} title="Close" className="ai-icon-btn" data-id="element-69" data-mp="bcn78j0bcg2p">
            <X size={16} data-id="element-70" data-mp="ga6m9l4u4wvp" />
          </button>
        </div>
      </div>

      {/* Mode Toggle */}
      <div className="ai-mode-section" data-id="element-71" data-mp="25p3arc1q5g3v">
        <div className="ai-mode-toggle" data-id="element-72" data-mp="25q619iv4xgj9">
          <button className={`ai-mode-pill ${mode === 'nlq' ? 'active' : ''}`} onClick={() => setMode('nlq')} data-id="element-73" data-mp="2aopl9dq64i8z">
            Ondemand AI
          </button>
          <button className={`ai-mode-pill ${mode === 'workfront' ? 'active' : ''}`} disabled={!isWorkfrontOrg} onClick={() => setMode('workfront')} title={isWorkfrontOrg ? 'Switch to Workfront AI' : `Requires ${WORKFRONT_ORG_NAME} org to be selected`} data-id="element-74" data-mp="287pytu8lgxj6">
            Workfront AI
          </button>
        </div>
        <div className="ai-subtitle" data-id="element-75" data-mp="2rxiiys55p30a">
          {mode === 'workfront' ? 'Workfront assistant' : 'AI-powered data assistant'}
        </div>
      </div>

      {/* Mode Content */}
      {mode === 'workfront' ? <WorkfrontAiChat onError={() => {}} data-id="element-76" data-mp="2i65ortvvy0r3" /> : <NlqChatPanel deals={deals} touchpoints={touchpoints} onError={() => {}} data-id="element-77" data-mp="2d9xbkm190hmk" />}
    </div>;
}